import React from 'react';
import useFadeIn from './useFadeIn';
import './Skills.css';

const SKILLS = [
  'React', 'Angular', 'Next.js', 'TypeScript', 'JavaScript',
  'HTML', 'CSS', 'Tailwind', 'Redux', 'Node.js',
  'Python', 'Java', 'Go', 'C++', 'Haskell',
  'MongoDB', 'SQL', 'Redis', 'Kafka', 'Firebase',
  'Docker', 'Kubernetes', 'AWS', 'Git', 'Figma', 'Blockchain',
];

const TOOLS = ['VS Code', 'IntelliJ', 'Postman', 'GitHub', 'Linux', 'macOS'];

function Skills() {
  const ref = useFadeIn();

  return (
    <section id="skills" className="section fade-in" ref={ref}>
      <p className="section-eyebrow">02 — Skills</p>
      <h2 className="section-heading">Tech Stack</h2>
      <div className="section-divider" />

      <div className="skills-grid">
        {SKILLS.map((skill) => (
          <div className="skill-pill" key={skill}>{skill}</div>
        ))}
      </div>

      <h3 className="tools-heading">Tools I Use</h3>
      <div className="tools-row">
        {TOOLS.map((tool) => (
          <div className="tool-badge" key={tool}>{tool}</div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
